// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2zCh7","inputWrap":"styles_inputWrap__2_n6H","input":"styles_input__9-QPZ"};